import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { Chip, SectionHeader, Loading, EmptyState } from "@/components/brand";
import { TrainerCard } from "@/components/cards";

export default function Trainers() {
  const [category, setCategory] = useState("");
  const [q, setQ] = useState("");
  const cats = useQuery({ queryKey: ["categories"], queryFn: () => api("/categories") });
  const query = new URLSearchParams();
  if (category) query.set("category", category);
  if (q) query.set("q", q);
  const trainers = useQuery({ queryKey: ["trainers", { category, q }], queryFn: () => api(`/trainers?${query.toString()}`) });

  return (
    <div data-testid="trainers-screen" className="space-y-5">
      <SectionHeader title="Find a Trainer" subtitle="Certified & verified professionals." />
      <div className="relative">
        <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-mutedgrey" />
        <input data-testid="trainer-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search trainers"
          className="w-full h-12 pl-11 pr-4 rounded-pill border border-line bg-surface2 font-body text-[15px] outline-none focus:border-brand" />
      </div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
        <Chip label="All" selected={!category} onClick={() => setCategory("")} testID="trainer-cat-all" />
        {(cats.data ?? []).map((c) => <Chip key={c.key} label={c.name} selected={category === c.key} onClick={() => setCategory(c.key)} testID={`trainer-cat-${c.key}`} />)}
      </div>
      {trainers.isLoading ? <Loading /> : (trainers.data ?? []).length === 0 ? (
        <EmptyState title="No trainers found" subtitle="Try another specialty or search." />
      ) : (
        <div className="grid md:grid-cols-2 gap-4">{(trainers.data ?? []).map((t) => <TrainerCard key={t.user_id} item={t} />)}</div>
      )}
    </div>
  );
}
